/*
Vue component that do 2 things on instance creation:
- getCart: Count cart components via xhr call to admin-ajax.php?action=cart_count_items
- initStickyHeader: Listen to scroll event in order to hide header if scroll is not at top
The components listen events called in twig templates:
- show main menu on the right: toggleMainMenu()

*/
const vueHeader = function initHeader()
{
  new Vue(
    {
      el: "#header",
      data: go_header,
      computed : {
        cartStatus : function()
        {
          return (this.cart_count_items > 0) ? "has-items" : "empty";
        },

        mainMenuStatus : function()
        {
          // DEBUG
          // return 'toggled';
          let status = "";
          if (document.getElementById("header").classList.contains("scrolled") ) {
            status +=" scrolled ";
          }

          if (this.mainMenuActive) {
            status += " toggled ";
          }

          return status;
        },

        langMenuStatus : function()
        {
          return (this.langMenuActive) ? 'toggled' : '';
        }
      },
      methods :
      {

        toggleLanguageMenu : function()
        {
          this.langMenuActive = (this.langMenuActive) ? false : true;
        },

        toggleMainMenu : function( type )
        {
          if ( typeof type === "string" && type==="focus") {
            if (window.innerHeight > window.innerWidth) {
              return false;
            }
          }

          this.mainMenuActive =  (this.mainMenuActive) ? false : true;
          document.querySelector("html").classList.toggle("freeze");

          $(".collection-layer").removeClass("active");
        },

        closeMainMenu : function ()
        {
          this.mainMenuActive =  false;
          document.querySelector("html").classList.remove("freeze");
          $(".collection-layer").removeClass("active");
        },

        toggleSubMenu : function ( parentId)
        {
          if (document.getElementById(parentId).classList.contains("active")) {
            document.getElementById(parentId).classList.remove("active");
          } else {
            $(".with-children").removeClass("active");
            document.getElementById(parentId).classList.add("active");
          }

        },

        getCart : function ()
        {
          var data = {
            action: 'cart_count_items',
            t : Date.now()
          };

          $.get(xhrUrl, data, this.getCart__callback);
        },

        getCart__callback : function (response)
        {
          // _log(response);
          if ( typeof response === "object" && !isNaN(response.cart_count)) {
            this.cart_count_items = response.cart_count;
          }
        },

        initStickyHeader : function () {
          var lastScrollTop = 0;
          // _log("stickyHeader");
          this.isTransparent = (document.getElementById("body").classList.contains("transparent"));

          window.addEventListener('scroll', this.handleScrollStatus);
        },

        handleScrollStatus : function(event) {
          if (!document.querySelector(".gform_confirmation_wrapper")) {
            const currentScrollY  = window.scrollY;

            const headerHeight = 120;
            // reset classes
            if (currentScrollY === 0) {
              document.getElementById("header").classList.remove("vanished", "scrolled");
              // add transparency if it was active
              if(this.isTransparent) {
                document.getElementById("body").classList.add("transparent")
              }
            // vanish header
            } else if (!document.getElementById("header").classList.contains("vanished") && currentScrollY >= headerHeight && currentScrollY > this.lastScrollTop) {
              document.getElementById("header").classList.add("vanished");
            // show header on scroll up
            } else if (currentScrollY < this.lastScrollTop && currentScrollY > headerHeight) {
              document.getElementById("header").classList.remove("vanished");
              document.getElementById("header").classList.add("scrolled");
              document.getElementById("body").classList.remove("transparent")
            }

            this.lastScrollTop = currentScrollY;
          } else {
            document.getElementById("header").classList.remove("scrolled");
          }
        }
      },

      created : function()
      {
        this.getCart();
        this.initStickyHeader();
        // this.toggleMainMenu();
      }
    });

}


export { vueHeader };